import { createContext, useContext, useLayoutEffect } from "react";

export const EmbedChromeContext = createContext(null);

export const isFramerEmbedRoute = (pathname = "") => {
  const segments = pathname.split("/").filter(Boolean);

  return Boolean(
    (segments[0] === "register" && segments[1]) ||
      (segments[0] === "confirmation" && segments[1]) ||
      (segments[1] === "confirmation" && segments[2]) ||
      (segments[2] === "confirmation" && segments[3]),
  );
};

export const useEmbeddedPageChrome = (hideChrome) => {
  const setHideEmbeddedChrome = useContext(EmbedChromeContext);

  useLayoutEffect(() => {
    if (!setHideEmbeddedChrome || hideChrome == null) return undefined;

    setHideEmbeddedChrome(hideChrome);

    return () => {
      setHideEmbeddedChrome(false);
    };
  }, [hideChrome, setHideEmbeddedChrome]);
};
